import { useEffect, useState } from 'react';

const navItems = [
  { label: '首页', href: '#top' },
  { label: '快讯爆料', href: '#feed' },
  { label: '精选合集', href: '#collections' },
  { label: '打包资源', href: '#downloads' },
  { label: '社区分区', href: '#boards' },
  { label: '资源图库', href: '#gallery' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const light = !scrolled && !menuOpen;

  return (
    <header className="fixed inset-x-0 top-0 z-50">
      <div className="hidden items-center justify-between bg-secondary-950 px-4 py-2 text-xs text-background-50/75 md:flex md:px-8">
        <div className="flex items-center gap-5">
          <span className="flex items-center gap-1.5">
            <span className="flex h-3.5 w-3.5 items-center justify-center">
              <i className="ri-bookmark-3-line text-[13px]"></i>
            </span>
            新手指南
          </span>
          <span className="flex items-center gap-1.5">
            <span className="flex h-3.5 w-3.5 items-center justify-center">
              <i className="ri-download-2-line text-[13px]"></i>
            </span>
            打包下载入口
          </span>
          <span className="flex items-center gap-1.5">
            <span className="flex h-3.5 w-3.5 items-center justify-center">
              <i className="ri-feedback-line text-[13px]"></i>
            </span>
            意见反馈
          </span>
        </div>
        <div className="flex items-center gap-4">
          <span className="flex items-center gap-1.5">
            <span className="h-1.5 w-1.5 animate-soft-pulse rounded-full bg-accent-400"></span>
            今日已更新 128 条 · 10:42 同步
          </span>
          <span className="text-background-50/50">资源库已整理至最新一期</span>
        </div>
      </div>

      <div
        className={`transition-colors duration-300 ${
          scrolled || menuOpen
            ? 'border-b border-background-200 bg-background-50/95 backdrop-blur'
            : 'bg-transparent'
        }`}
      >
        <div className="flex items-center justify-between gap-4 px-4 py-3 md:px-8 md:py-4">
          <a href="#top" className="flex cursor-pointer items-center gap-2.5">
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500">
              <i className="ri-emotion-laugh-line text-xl text-background-50"></i>
            </span>
            <span className="leading-tight">
              <span
                className={`block font-heading text-lg font-bold tracking-tight transition-colors ${
                  light ? 'text-background-50' : 'text-foreground-950'
                }`}
              >
                爱黑料网
              </span>
              <span
                className={`hidden text-[11px] tracking-widest transition-colors md:block ${
                  light ? 'text-background-50/70' : 'text-foreground-500'
                }`}
              >
                RESOURCE HUB
              </span>
            </span>
          </a>

          <nav className="hidden items-center gap-1 lg:flex">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className={`whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                  light
                    ? 'text-background-50/85 hover:bg-background-50/10 hover:text-background-50'
                    : 'text-foreground-700 hover:bg-background-100 hover:text-primary-600'
                }`}
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2 md:gap-3">
            <div
              className={`hidden items-center gap-2 rounded-md border px-3 py-2 transition-colors xl:flex ${
                light ? 'border-background-50/25 bg-background-50/10' : 'border-background-200 bg-background-100'
              }`}
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className={`ri-search-line text-sm ${light ? 'text-background-50/70' : 'text-foreground-500'}`}></i>
              </span>
              <input
                type="text"
                placeholder="搜合集 / 打包 / 关键词"
                className={`w-40 bg-transparent text-sm outline-none placeholder:text-sm ${
                  light
                    ? 'text-background-50 placeholder:text-background-50/60'
                    : 'text-foreground-800 placeholder:text-foreground-400'
                }`}
              />
            </div>

            <button
              type="button"
              className="hidden cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:flex"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-download-cloud-2-line text-sm"></i>
              </span>
              打包入口
            </button>

            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              aria-label="打开菜单"
              className={`flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border transition-colors lg:hidden ${
                light ? 'border-background-50/25 text-background-50' : 'border-background-200 text-foreground-900'
              }`}
            >
              <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-lg`}></i>
            </button>
          </div>
        </div>

        {menuOpen ? (
          <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-3 lg:hidden">
            <nav className="flex flex-col">
              {navItems.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={() => setMenuOpen(false)}
                  className="flex items-center justify-between border-b border-background-200 py-3 text-sm font-medium text-foreground-800"
                >
                  {item.label}
                  <span className="flex h-4 w-4 items-center justify-center">
                    <i className="ri-arrow-right-s-line text-foreground-400"></i>
                  </span>
                </a>
              ))}
            </nav>
            <button
              type="button"
              className="mt-4 flex w-full cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-sm font-medium text-background-50"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-download-cloud-2-line text-sm"></i>
              </span>
              打开打包下载入口
            </button>
          </div>
        ) : null}
      </div>
    </header>
  );
}